export default "__VITE_PUBLIC_ASSET__fcec4a4b__"